import React, { Component } from 'react';
import _ from 'lodash';
import dayjs from 'dayjs';
import { Button, Form, Select, DatePicker, Tooltip } from 'antd';
import SelectTenant from '@/components/SelectTenant';
import SelectUser from '@/components/SelectUser';
import SelectOrder from '@/components/SelectOrder';
import styles from './transactions.module.scss';
import { transactionTypes } from '../constants';
import FilterItem from '@/components/FilterItem';
import * as apis from '@/apis';

const { RangePicker } = DatePicker;
const transactionTypeKeys = Object.keys(transactionTypes);
const isManagerMode = process.env.APP_MODE === 'manager';

@Form.create({
  onValuesChange: (props, changedValues, values) => {
    if (values.time_range && values.time_range[0] && values.time_range[1]) {
      values.time_range = [
        values.time_range[0].startOf('day').valueOf(),
        values.time_range[1].endOf('day').valueOf(),
      ];
    } else {
      delete values.time_range;
    }

    values = _.pickBy(values, _.identity);

    props.onChange(values);
  },
})
export default class Filters extends Component {
  normalizeTenant = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value;
    }

    if (value && value._id) {
      return value._id;
    }

    return null;
  };

  normalizeOrder = (value, prevValue, allValues) => {
    if (typeof value === 'string') {
      return value;
    }
    if (value && value._id) {
      return value._id;
    }
    return null;
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { query = {} } = this.props;
    const downloadUrl = apis.downloadTransactionsUrl(query);

    return (
      <Form layout="inline">
        <div className={styles.filters}>
          <FilterItem className={styles.row} label="交易类型">
            {getFieldDecorator('type', {
              initialValue: query.type || null,
            })(
              <Select placeholder="请选择交易类型" style={{ width: 200 }}>
                <Select.Option value={null}>全部</Select.Option>
                {transactionTypeKeys.map((key) => (
                  <Select.Option key={key} value={key}>
                    {transactionTypes[key]}
                  </Select.Option>
                ))}
              </Select>
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="企业">
            {getFieldDecorator('tenant', {
              normalize: this.normalizeTenant,
              initialValue: query.tenant || null,
            })(
              <SelectTenant style={{ width: 140 }} placeholder="输入企业名称" />
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="师傅">
            {getFieldDecorator('user', {
              initialValue: query.user || null,
            })(
              <SelectUser
                type="worker"
                selectKey="user._id"
                style={{ width: 140 }}
                placeholder="输入师傅姓名"
              />
            )}
          </FilterItem>
          <FilterItem className={styles.row} label="工单">
            {getFieldDecorator('order', {
              normalize: this.normalizeOrder,
              initialValue: query.order || null,
            })(<SelectOrder style={{ width: 180 }} placeholder="输入工单号" />)}
          </FilterItem>
          <FilterItem className={styles.row} label="日期范围">
            {getFieldDecorator('time_range', {
              initialValue: query.time_range
                ? [dayjs(+query.time_range[0]), dayjs(+query.time_range[1])]
                : [0, 0],
            })(<RangePicker style={{ width: 240 }} />)}
          </FilterItem>
          <FilterItem className={styles.row}>
            <div className={styles.submitBtns}>
              <Tooltip title="注意：将下载当前查询条件内所有数据（无需再次按页下载）">
                <Button type="link" size="small" href={downloadUrl}>
                  下载所有数据
                </Button>
              </Tooltip>
            </div>
          </FilterItem>
        </div>
      </Form>
    );
  }
}
